import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import {
  DEFAULT_LOCALE,
  EN_LOCALE,
  localizePath,
  stripLocalePrefix,
  isPublicLocalizedPath,
} from '../../i18n/routing';
import { loadLocaleBundle } from '../../i18n/loadLocaleBundle';

const LANGUAGES = [
  { code: DEFAULT_LOCALE, label: 'Français', flag: '🇫🇷' },
  { code: EN_LOCALE, label: 'English', flag: '🇬🇧' },
];

function LanguageSelector() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const currentLang = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  const changeLanguage = async (code) => {
    if (code === i18n.language) return;

    if (isPublicLocalizedPath(location.pathname)) {
      const barePath = stripLocalePrefix(location.pathname);
      navigate(localizePath(barePath, code));
    }

    await loadLocaleBundle(code);
    i18n.changeLanguage(code);
  };

  return (
    <Dropdown className="me-2">
      <Dropdown.Toggle variant="outline-secondary" size="sm">
        {currentLang.flag} {currentLang.label}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {LANGUAGES.map((lang) => (
          <Dropdown.Item
            key={lang.code}
            active={lang.code === i18n.language}
            onClick={() => changeLanguage(lang.code)}
          >
            {lang.flag} {lang.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default LanguageSelector;
